import { defineType } from 'sanity';

export const factory = defineType({
    name: 'factory',
    title: 'Page Component Factory',
    type: 'array',
    of: [
        { type: 'hero' },
        { type: 'coreValues' },
        { type: 'cta' },
        { type: 'trust' },
        { type: 'partners' },
        { type: 'showcaseGrid' },
        { type: 'qualityPillars' },
        { type: 'statistics' },
        { type: 'intro' },
        { type: 'videoSection' },
        { type: 'timelineSection' },
        { type: 'tabsSection' },
        { type: 'carouselSection' },
        { type: 'faq' },
        { type: 'team' },
        { type: 'accordionSection' },
        { type: 'imageGallery' },
        { type: 'productShowcase' },
        { type: 'heroWithMascot' },
    ],
});
